import React from 'react'
import Box from '@material-ui/core/Box'
import { App } from '../../../utils/objects'
import { useAppContext } from '../../../contexts/AppContext'
import { makeStyles } from '@material-ui/core/styles'
import ContentTabs from './ContentTabs'

const useStyles = makeStyles(theme => ({
    tabsContainer: {

    }
}))

/**
 *
 */
const Content = (): JSX.Element => {
    const classes = useStyles()
    const appContext = useAppContext()
    const app = appContext.app as App

    return (
        <Box>
            <Box className={classes.tabsContainer}>
                <ContentTabs app={app} />
            </Box>
        </Box>
    )
}

export default Content
